import { render, staticRenderFns } from "./dimssa-button.vue?vue&type=template&id=57b84dda&scoped=true"
import script from "./dimssa-button.vue?vue&type=script&lang=ts"
export * from "./dimssa-button.vue?vue&type=script&lang=ts"
import style0 from "./dimssa-button.vue?vue&type=style&index=0&id=57b84dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b84dda",
  null
  
)

export default component.exports